import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class KullanimSekliAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "KullanimSekliListe";
        super(baseUrl);
    }

    getKullanimSekliListe(kullanimSekliKodu?: number) {
        return this.get("", { params: { kullanimSekliKodu: kullanimSekliKodu } })

    }
}
export default new KullanimSekliAPI();